import {Popper, PopperTrigger} from '@baidu/luffy';
import styles from './index.module.scss';
import {useState} from 'react';
import {ArrowDownFillSvg, ArrowDownSvg} from '@/icons';
import Icon, {IconSize} from '@/components/Icon';
import classNames from 'classnames';
import {getDocFillSvgByType} from '@/utils/docType';
import routers, {buildPath} from '@/config/routers';

interface batchCopyProps {
    batchList: any[];
    action: 'copy' | 'move';
}

export default function BatchOperate(props: batchCopyProps) {
    const {batchList, action} = props;

    const [visible, setVisible] = useState(false);

    if (!batchList.length) {
        return null;
    }

    const noPowerList = batchList.filter(item => item.perm === 'N');

    function getIcon(item: any) {
        return <Icon
            svg={getDocFillSvgByType(item.type as number | undefined)}
            size={IconSize.XL}
            className={styles.teamIconSize}
            noSpace
        />;
    }

    function openUrl(item: any) {
        if (!item) {
            return;
        }
        const path = buildPath(routers.Knowledge.docPath, {
            docGuid: item.docGuid || '',
            spaceGuid: item.spaceGuid || '',
            groupGuid: item.groupGuid || '',
            repositoryGuid: item.repositoryGuid || '',
        });
        window.open(path);
    }

    return <div className={styles.wrapper}>
        <span>{`已选择 ${batchList.length} 篇文档，`}</span>
        {noPowerList.length
            ? <PopperTrigger type={'click'} visible={visible} onChange={setVisible}>
                <div className={classNames(styles.dropMenuText, visible && styles.active)}>
                    <span>{`其中 ${noPowerList.length} 篇无权限${action === 'copy' ? '复制' : '移动'}`}</span>
                    <Icon svg={ArrowDownFillSvg} />
                </div>
                <Popper
                    className=""
                    withArrow={false}
                    placement={'bottom-start'}
                >
                    <div className={styles.noPowerList}>
                        {
                            noPowerList.map((item: any) => (
                                <div key={item.docGuid} className={styles.noPowerItem} onClick={() => openUrl(item)}>
                                    {getIcon(item)}
                                    <span className={styles.itemName}>{item.name}</span>
                                </div>
                            ))
                        }
                    </div>
                </Popper>
            </PopperTrigger>
            : ''}
        <span>请指定位置：</span>
    </div>;
}
